import { defineMessages } from 'react-intl';

import {
	PriceFinderMessages,
	ProductPlan,
} from '@/components/wpl/pricing/src/price-finder/constants';
import PriceFinderSection from '@/components/wpl/pricing/src/price-finder/price-finder';
import { PriceFinderContextProvider } from '@/components/wpl/pricing/src/price-finder/price-finder-context.tsx';
import { usePricingPlanComparison } from '@/components/wpl/pricing/src/pricing-content-context.tsx';

import { JiraProductDiscoveryPricingPageProps } from '../../../../../../../../../pages/software/jira/product-discovery/pricing/jira-product-discovery-pricing-page';

export const JiraProductDiscoveryPriceFinder = (
	props: JiraProductDiscoveryPricingPageProps,
	// eslint-disable-next-line complexity
) => {
	const content = {
		free: usePricingPlanComparison('Free'),
		standard: usePricingPlanComparison('Standard'),
		premium: usePricingPlanComparison('Premium'),
	};

	const jiraProductDiscoveryProductPlans: ProductPlan[] = [
		{
			planName: content.free?.planTitleExternal ?? 'Free',
			offeringSku: 'jira-servicedesk-free',
			description: content.free?.planOneLiner ?? '',
			recommendationLimit: 0,
			signupLimit: 20000,
			signupURLSuffix: '?bundle=jira-product-discovery&edition=free&signupSource=pricing',
		},
		{
			planName: content.standard?.planTitleExternal ?? 'Standard',
			offeringSku: 'jira-product-discovery-standard',
			description: content.standard?.planOneLiner ?? '',
			recommendationLimit: 3,
			signupLimit: 20000,
			signupURLSuffix: '?bundle=jira-product-discovery&edition=standard&signupSource=pricing',
		},
		{
			planName: content.premium?.planTitleExternal ?? 'Premium',
			offeringSku: 'jira-product-discovery-premium-sku',
			description: content.premium?.planOneLiner ?? '',
			recommendationLimit: 50,
			signupLimit: 20000,
			signupURLSuffix: '?bundle=jira-product-discovery&edition=premium&signupSource=pricing',
		},
	];

	const messages: PriceFinderMessages = defineMessages({
		unitCountInputTextRedesign: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTextRedesign',
			defaultMessage: 'Team size:',
		},
		unitCountInputTerm: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputTerm',
			defaultMessage: 'creators',
		},
		unitCountInputText: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.unitCountInputText',
			defaultMessage: 'How many agents are on your team?',
		},
		cardOverSignupLimit: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.cardOverSignupLimit',
			defaultMessage: "Your agent count exceeds this plan's limit",
		},
		cardEnterpriseMinimumCount: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.cardEnterpriseMinimumCount',
			defaultMessage:
				'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more agents above',
			description: 'Enterprise is a plan name and should not be translated',
		},
		cardUnitCountTierRange: {
			id: 'JiraProductDiscoveryPricingPage.priceFinder.cardUnitCountTierRange',
			defaultMessage: 'Creator tier: {lowerLimit} - {upperLimit}',
		},
		cardMonthlyPerUnitCount: {
			id: 'JiraProductDiscoveryPricingPageTeam24.priceFinder.cardMonthlyPerUnitCount',
			defaultMessage: 'per creator / month',
		},
	});

	return (
		<PriceFinderContextProvider
			dataProductKey="jiraProductDiscovery"
			productPlans={jiraProductDiscoveryProductPlans}
			defaultUnitCount={10}
			enterpriseMinimumCount={201}
		>
			<PriceFinderSection
				messages={messages}
				serverSideCCPPricing={props.pricing?.ccpPricingData?.jiraProductDiscovery}
				countryCode={props.countryCode}
			/>
		</PriceFinderContextProvider>
	);
};

JiraProductDiscoveryPriceFinder.displayName = 'JiraProductDiscoveryPriceFinder';
